import type { TemplateProps } from '../types';
import { ChatIcon } from '../../components/ChatIcon';

export function Trigger({ config, onOpen, accentColor }: TemplateProps): preact.JSX.Element {
  return (
    <button
      class="yd-bar-trigger"
      onClick={(e: Event) => { e.stopPropagation(); onOpen(); }}
      aria-label="Open chat"
      style={{ borderTopColor: accentColor }}
    >
      <span class="yd-bar-name">{config.name}</span>
      <span class="yd-bar-placeholder">Ask a question...</span>
      <span class="yd-bar-icon" style={{ color: accentColor }}>
        <ChatIcon size={20} />
      </span>
    </button>
  );
}
